import { useNavigate, useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

export function useLeaveMbcFlow(): () => void {
  const navigate = useNavigate();
  const router = useRouter();

  return useCallback(() => {
    if (router.history.canGoBack()) {
      router.history.back();

      return;
    }

    void navigate({
      search: { filter: "all", tab: "drafts" },
      to: "/requests",
    });
  }, [navigate, router]);
}
